import { z } from 'zod'

export interface UsernameSchemaTypes {
	required: string
	minLength: string
	maxLength: string
	pattern: string
}

export interface PasswordSchemaTypes {
	required: string
	minLength: string
	maxLength: string
}

export interface NameSchemaTypes {
	required: string
	minLength: string
	maxLength: string
}

export interface EmailSchemaTypes {
	required: string
	invalid: string
	minLength: string
	maxLength: string
}

export interface PasswordAndConfirmPasswordSchemaTypes {
	matches: string
}

export const UsernameSchema = (translations: UsernameSchemaTypes) =>
	z
		.string({ required_error: translations.required })
		.min(3, { message: translations.minLength })
		.max(100, { message: translations.maxLength })
		// .regex(/^[a-zA-Z0-9_]+$/, {
		// 	message: translations.pattern,
		// })
		// users can type the username in any case, but we store it in lowercase
		.transform(value => value.toLowerCase())

export const PasswordSchema = (translations: PasswordSchemaTypes) =>
	z
		.string({ required_error: translations.required })
		.min(6, { message: translations.minLength })
		.max(100, { message: translations.maxLength })

export const NameSchema = (translations: NameSchemaTypes) =>
	z
		.string({ required_error: translations.required })
		.min(3, { message: translations.minLength })
		.max(40, { message: translations.maxLength })

export const EmailSchema = (translations: EmailSchemaTypes) =>
	z
		.string({ required_error: translations.required })
		.email({ message: translations.invalid })
		.min(3, { message: translations.minLength })
		.max(100, { message: translations.maxLength })
		// users can type the email in any case, but we store it in lowercase
		.transform(value => value.toLowerCase())

export const PasswordAndConfirmPasswordSchema = (
	passwordTranslations: PasswordSchemaTypes,
	matchingPasswordTranslations: PasswordAndConfirmPasswordSchemaTypes,
) =>
	z
		.object({
			password: PasswordSchema(passwordTranslations),
			confirmPassword: PasswordSchema(passwordTranslations),
		})
		.superRefine(({ confirmPassword, password }, ctx) => {
			if (confirmPassword !== password) {
				ctx.addIssue({
					path: ['confirmPassword'],
					code: 'custom',
					message: matchingPasswordTranslations.matches,
				})
			}
		})
